import styles from "./Promocode.module.scss";
import TitleUpdater from "../../../components/shared/title/TitleUpdater";
import InputComponent from "../../../components/shared/input/InputComponent";
import MainButton from "../../../components/shared/button/MainButton";
import ServiceBalance from "../../../assets/images/otp/Service Balance Icon.svg";
import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { PromoCodeServices } from "../../../services/promocode.service";
import {
  ApiPaginationResponse,
  PromoCodeDataType,
} from "../../../interface/site.interface";
import OrderRow from "../../../components/pages/courier/OrderRow";
import Spinner from "../../../components/shared/spinner/Spinner";
import Card from "../../../components/pages/card/Card";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/store";
import { fetchTranslation } from "../../../redux/Slices/translationDataSlice";
import ArrowImage from "../../../assets/images/pages/login/CaretLeft.svg";

function Promocode() {
  const [promoCode, setPromoCode] = useState<PromoCodeDataType[]>([]);
  const [promoCodeInput, setPromoCodeInput] = useState<string>("");
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [successMessage, setSuccessMessage] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(true);
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const language = useSelector((state: RootState) => state.language.language);
  const dispatch = useDispatch<AppDispatch>();
  const [paginationData, setPaginationData] =
    useState<ApiPaginationResponse<PromoCodeDataType> | null>(null);
  const { data } = useSelector((state: RootState) => state.translationData);

  useEffect(() => {
    setLoading(true);
    PromoCodeServices.getAllPromocode()
      .then((res) => {
        setPromoCode(res.data.data.data);
        setPaginationData(res?.data.data);
      })
      .catch((err) => {
        console.error("Error fetching promo codes", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [language]);

  const handlePromoCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPromoCodeInput(e.target.value);
    const value = e.target.value;

    if (errors.content && value.trim()) {
      setErrors((prevErrors) => ({ ...prevErrors, content: "" }));
    }
  };

  const hasUnusedPromoCode = () => {
    return promoCode.some((code) => !code.used_at || code.used_at === "");
  };

  const submitPromoCode = async () => {
    setIsSubmitting(true);

    const payload = {
      code: promoCodeInput,
    };

    try {
      const response = await PromoCodeServices.PostPromoCode(payload);

      if (response?.data?.original?.case === "error") {
        setErrorMessage(response.data.original.content);
        setSuccessMessage("");
      } else {
        setSuccessMessage(data?.promo_added || "");
        toast.success(data?.promo_added);
        setErrorMessage("");
        setPromoCodeInput("");
        setLoading(true);
        PromoCodeServices.getAllPromocode()
          .then((res) => setPromoCode(res.data.data.data))
          .catch(() => {})
          .finally(() => setLoading(false));
      }
    } catch (error: any) {
      console.error("Error submitting promo code", error);
      setErrorMessage(data?.error_occurred || "");
      setSuccessMessage("");
      setErrors(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (hasUnusedPromoCode()) {
      setShowConfirmModal(true);
      return;
    }

    submitPromoCode();
  };

  const handleConfirmModal = () => {
    setShowConfirmModal(false);
    submitPromoCode();
  };

  const handleCancelModal = () => {
    setShowConfirmModal(false);
  };

  const initialRender = useRef(true);

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
      if (!data) {
        dispatch(fetchTranslation());
      }
    } else {
      dispatch(fetchTranslation());
    }
  }, [dispatch, language]);

  const handlePageChange = async (urlOrPage: string | number) => {
    setLoading(true);
    try {
      let res;
      if (typeof urlOrPage === "string") {
        res = await PromoCodeServices.getAllPromocode(urlOrPage);
      } else {
        const url = `/promocode?page=${urlOrPage}`;
        res = await PromoCodeServices.getAllPromocode(url);
      }
      setPromoCode(res.data.original.data);
      setPaginationData(res.data.original);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <TitleUpdater
        title={
          data?.colibri && data?.auth_left_sidebar_promo_code
            ? `${data?.colibri} | ${data?.auth_left_sidebar_promo_code}`
            : "Colibri"
        }
      />
      <form className={styles.AmazonOtp} onSubmit={handleSubmit}>
        <div className={styles.customAllInputWrapper}>
          <div className={styles.customInputWrapper}>
            <div className={styles.iconBlock}>
              <div className={styles.iconCircle}>
                <img src={ServiceBalance} alt="track" />
              </div>
            </div>
            <div className={styles.customInputContent}>
              <span>{data?.auth_promocode_placeholder}</span>
              {/* <InputComponent
                label=""
                type="text"
                name="track"
                placeholder="00000"
                isPassword={false}
                className={styles.inputForOtp}
                value={promoCodeInput}
                onChange={handlePromoCodeChange}
                error={errors.content}
              /> */}
              <input
                type="text"
                name="track"
                placeholder="00000"
                className={styles.inputForOtp}
                value={promoCodeInput}
                onChange={handlePromoCodeChange}
              />
            </div>
          </div>
          {errors.content && (
            <p className={styles.errorText}>{errors.content}</p>
          )}
        </div>
        <MainButton
          className={styles.form_submitBtn}
          text={data?.auth_promocode_confirm}
          type="submit"
          disabled={!promoCodeInput || isSubmitting}
        />
      </form>

      <div className={styles.pagination_part}>
        <p className={styles.pagination_title}>
          {data?.auth_left_sidebar_promo_code}
        </p>
        {(paginationData?.current_page === 1 &&
          paginationData?.next_page_url === null) ||
          (paginationData && (
            <div className={styles.pagination}>
              <img
                src={ArrowImage}
                className={`${styles.pagination_arrow_left} ${
                  !paginationData.prev_page_url ? styles.disabled : ""
                }`}
                alt="Prev"
                onClick={() => {
                  if (paginationData.prev_page_url) {
                    handlePageChange(paginationData.prev_page_url);
                  }
                }}
              />

              {[...Array(paginationData.last_page)].map((_, index) => {
                const page = index + 1;
                return (
                  <p
                    key={page}
                    className={`${styles.pagination_count} ${
                      paginationData.current_page === page ? styles.active : ""
                    }`}
                    onClick={() => handlePageChange(page)}
                  >
                    {page}
                  </p>
                );
              })}

              <img
                src={ArrowImage}
                className={`${styles.pagination_arrow_right} ${
                  !paginationData.next_page_url ? styles.disabled : ""
                }`}
                alt="Next"
                onClick={() => {
                  if (paginationData.next_page_url) {
                    handlePageChange(paginationData.next_page_url);
                  }
                }}
              />
            </div>
          ))}
      </div>

      {loading ? (
        <div
          className={styles.loadingWrapper}
          style={{ textAlign: "center", marginTop: 20 }}
        >
          <Spinner size="large" />
        </div>
      ) : promoCode.length > 0 ? (
        <table className={styles.order_history_list}>
          <thead>
            <tr>
              <th>{data?.auth_promocode_title || "Promokod"}</th>
              <th>{data?.country || "Ölkə"}</th>
              <th>{data?.used_date || "İstifadə tarixi"}</th>
              <th>{data?.expired_date || "Son istifadə tarixi"}</th>
            </tr>
          </thead>
          <tbody>
            {promoCode.map((order, index) => (
              <OrderRow key={index} {...order} promoCode={true} />
            ))}
          </tbody>
        </table>
      ) : (
        <div style={{ marginTop: "30px" }}>{data?.promo_not_found}</div>
      )}
      <div className={styles.courier_card} style={{ marginTop: "30px" }}>
        {promoCode?.map((order, index) => (
          <Card key={index} {...order} promoCode={true} />
        ))}
      </div>

      {showConfirmModal &&
        createPortal(
          <div className={styles.modalOverlay}>
            <div className={styles.modalContent}>
              <p className={styles.modalText}>
                İstifadə edilməmiş promokodunuz silinəcək. Davam etmək
                istəyirsiniz?
              </p>
              <div className={styles.modalButtons}>
                <button
                  className={styles.modalConfirmBtn}
                  onClick={handleConfirmModal}
                >
                  {data?.auth_logout_yes || "Bəli"}
                </button>
                <button
                  className={styles.modalCancelBtn}
                  onClick={handleCancelModal}
                >
                  {data?.auth_cancel || "Xeyr"}
                </button>
              </div>
            </div>
          </div>,
          document.body
        )}
    </>
  );
}

export default Promocode;
